//
//  DocumentationLegacyPageBlockEmbedGeneric.ts
//  Pulsar Language
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Imports
import { Size } from "../../support/SDKSize";
import { DocumentationLegacyPageBlock, } from "../SDKDocumentationLegacyPageBlock";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockEmbedGeneric extends DocumentationLegacyPageBlock {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children) {
        var _a, _b, _c;
        super(model, children);
        this.url = (_a = model.url) !== null && _a !== void 0 ? _a : null;
        this.size = new Size((_b = model.size) !== null && _b !== void 0 ? _b : null);
        this.caption = (_c = model.caption) !== null && _c !== void 0 ? _c : null;
    }
}
